import {
  PlayArrow as PlayArrowIcon,
  Stop as StopIcon,
} from '@mui/icons-material';
import { styled, Typography } from '@mui/material';

const TriggerButton = () => `
    border-radius: 50%;
    padding: 3px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  `;

export const StopIconStyled = styled(StopIcon)(
  ({ theme }) => `
      ${TriggerButton()}
      color: ${theme.palette.primary.dark};
      border: 1px solid ${theme.palette.primary.dark};
      background-color: ${theme.palette.primary.lighter};
    `,
);

export const PlayArrowIconStyled = styled(PlayArrowIcon)(
  ({ theme }) => `
      ${TriggerButton()}
      color: ${theme.palette.primary.dark};
      border: 1px solid ${theme.palette.primary.dark};
      background-color: ${theme.palette.primary.lighter};
      padding: 2px;
    `,
);

export const StyledLinkTypography = styled(Typography)(
  ({ theme, active }) => `
  ${active && `background-color: ${theme.palette.brand.lightBlue}`};
  &:hover {
    background-color: ${theme.palette.brand.lightGrey};
    }
  text-indent: 4px;
`,
);
